<template>
	<!-- Main Wrapper -->
	<div class="main-wrapper">
		<layout-header></layout-header>
		<layout-sidebar></layout-sidebar>

		<!-- Page Wrapper -->
		<div class="page-wrapper">
			<div class="content container-fluid">
				<componentheader :title="title" />

				<div class="row">
					<div class="col-xl-3 col-md-4">
						<settingsidebar />
					</div>

					<div class="col-xl-9 col-md-8">
						<div class="card card-table">
							<div class="card-header">
								<div class="row">
									<div class="col">
										<h5 class="card-title">Banks</h5>
									</div>
									<div class="col-auto">
										<a class="btn btn-outline-primary btn-sm" @click="addBankModal.show()"
											>Add New Bank</a
										>
									</div>
								</div>
							</div>
							<div class="card-table">
								<div class="card-body">
									<div class="table-responsive">
										<a-table
											:loading="isFetching"
											:columns="columns"
											:data-source="banks"
											:pagination="false"
										>
											<template #bodyCell="{ column, record, index }">
												<template v-if="column.key === 'index'">
													<span>{{ index + 1 }}</span>
												</template>
												<template v-else-if="column.key === 'preferred'">
													<span
														class="badge bg-success-light text-success-light text-capitalize"
														v-if="record.preferred"
														>Active</span
													>
													<span
														class="badge bg-danger-light text-danger-light text-capitalize"
														v-else
														>Inactive</span
													>
												</template>
												<template v-if="column.key === 'action'">
													<div class="d-flex align-items-center justify-content-start">
														<div class="dropdown dropdown-action">
															<a
																class="btn-action-icon"
																data-bs-toggle="dropdown"
																aria-expanded="false"
																>Action</a
															>
															<div class="dropdown-menu dropdown-menu-end">
																<ul>
																	<li>
																		<a @click="openEditModal(record)" class="dropdown-item"
																			><i class="far fa-edit me-2"></i>Edit</a
																		>
																	</li>
																	<li>
																		<a class="dropdown-item" @click="openModal(record, 'delete')"
																			><i class="far fa-trash-alt text-danger me-2"></i>Delete</a
																		>
																	</li>
																	<li v-if="record.preferred">
																		<a
																			@click="openModal(record, 'inactive')"
																			class="dropdown-item"
																			><i class="fa fa-times-circle text-danger me-2"></i>Make
																			inactive</a
																		>
																	</li>
																	<li v-if="!record.preferred">
																		<a
																			@click="openModal(record, 'preferred')"
																			class="dropdown-item"
																			><i class="fa fa-check-circle text-success me-2"></i>Mark as
																			Preferred</a
																		>
																	</li>
																</ul>
															</div>
														</div>
													</div>
												</template>
											</template>
										</a-table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- Add Category Modal -->
					<div id="add_bank" class="modal custom-modal fade" role="dialog">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<div class="modal-header border-0 pb-0">
									<div class="form-header modal-header-title text-start mb-0">
										<h4 class="mb-0">Add Bank</h4>
									</div>
									<button
										type="button"
										class="close"
										@click="closeAddModal"
										aria-label="Close"
									>
										<span class="align-center" aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<form @submit.prevent="addBank">
										<div class="form-group">
											<label>Bank name <span class="text-danger">*</span></label>

											<select
												v-if="currency === 'NGN'"
												class="form-select"
												:disabled="isResolving"
												@change="setCode()"
												v-model="form.bank_name"
											>
												<option value="">Select Bank</option>
												<option
													v-for="(bank, index) in bank_list"
													:key="index"
													:value="bank.name"
												>
													{{ bank.name }}
												</option>
											</select>

											<input
												v-else
												v-model="form.bank_name"
												class="form-control"
												type="text"
												required
											/>
										</div>
										<div class="form-group">
											<label>Account number <span class="text-danger">*</span></label>
											<div class="name-wrapper">
												<input
													v-model="form.account_number"
													:disabled="isResolving"
													type="text"
													@input="fetchAccount()"
													class="form-control"
													required
												/>
												<b-spinner
													v-if="isResolving"
													small
													label="Small Spinner"
													class="resolve-spinner"
												></b-spinner>
											</div>
										</div>
										<div class="form-group">
											<label>Account name <span class="text-danger">*</span></label>
											<input
												v-model="form.account_name"
												class="form-control bg-white"
												:disabled="currency === 'NGN'"
												type="text"
												required
											/>
										</div>
										<div class="form-group">
											<label>Additional Information </label>
											<textarea
												v-model="form.other_info"
												class="form-control"
												type="text"
											></textarea>
										</div>

										<label
											class="custom_check text-dark fw-medium mb-3"
											style="font-weight: 500"
										>
											<input
												type="checkbox"
												v-model="form.preferred"
												true-value="1"
												false-value="0"
												name="recurring"
											/>
											<span class="checkmark"></span> Set as preferred
										</label>

										<div class="submit-section">
											<button
												:disabled="isLoading || isResolving"
												type="submit"
												class="btn btn-primary add-tax-save-btn"
											>
												<span
													v-if="isLoading"
													class="spinner-border spinner-border-sm me-1"
													role="status"
													aria-hidden="true"
												></span>
												<span v-if="!isLoading">Add Bank</span>
												<span v-if="isLoading">Adding...</span>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					<!-- /Add Category Modal -->

					<!-- Edit Category Modal -->
					<div id="edit_bank" class="modal custom-modal fade" role="dialog">
						<div class="modal-dialog modal-dialog-centered" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Edit Bank</h5>
									<button
										type="button"
										class="btn-close"
										@click="closeEditModal"
										aria-label="Close"
									></button>
								</div>
								<div class="modal-body">
									<form @submit.prevent="updateBank">
										<div class="form-group">
											<label>Bank name <span class="text-danger">*</span></label>

											<select
												v-if="currency === 'NGN'"
												class="form-select"
												:disabled="isResolving"
												@change="setCode()"
												v-model="form.bank_name"
											>
												<option value="">Select Bank</option>
												<option
													v-for="(bank, index) in bank_list"
													:key="index"
													:value="bank.name"
												>
													{{ bank.name }}
												</option>
											</select>

											<input
												v-else
												v-model="form.bank_name"
												class="form-control"
												type="text"
												required
											/>
										</div>
										<div class="form-group">
											<label>Account number <span class="text-danger">*</span></label>
											<div class="name-wrapper">
												<input
													v-model="form.account_number"
													:disabled="isResolving"
													type="text"
													@input="fetchAccount()"
													class="form-control"
													required
												/>
												<b-spinner
													v-if="isResolving"
													small
													label="Small Spinner"
													class="resolve-spinner"
												></b-spinner>
											</div>
										</div>
										<div class="form-group">
											<label>Account name <span class="text-danger">*</span></label>
											<input
												v-model="form.account_name"
												class="form-control bg-white"
												:disabled="currency ==='NGN'"
												type="text"
												required
											/>
										</div>

										<div class="form-group">
											<label>Additional Information </label>
											<textarea
												v-model="form.other_info"
												class="form-control"
												type="text"
											></textarea>
										</div>

										<label
											class="custom_check text-dark fw-medium mb-3"
											style="font-weight: 500"
										>
											<input
												type="checkbox"
												v-model="form.preferred"
												true-value="1"
												false-value="0"
												name="recurring"
											/>
											<span class="checkmark"></span> Set as preferred
										</label>

										<div class="submit-section">
											<button
												:disabled="isLoading || isResolving"
												type="submit"
												class="btn btn-primary add-tax-save-btn"
											>
												<span
													v-if="isLoading"
													class="spinner-border spinner-border-sm me-1"
													role="status"
													aria-hidden="true"
												></span>
												<span v-if="!isLoading">Update Bank</span>
												<span v-if="isLoading">Updating...</span>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					<!-- /Edit Category Modal -->

					<!-- Delete Category Modal -->
					<div class="modal custom-fade fade" id="delete_bank" role="dialog">
						<div class="modal-dialog modal-dialog-centered modal-md">
							<div v-if="selectedItem" class="modal-content">
								<div class="modal-body">
									<div class="modal-text text-center">
										<h3
											v-if="selectedAction === 'preferred' || selectedAction === 'inactive'"
										>
											Preferred Bank
										</h3>
										<h3 v-else>Delete Bank</h3>
										<p v-if="selectedAction === 'preferred'">
											Are you sure want to make
											{{ selectedItem.bank_name }} your preferred bank?
										</p>
										<p v-else-if="selectedAction === 'inactive'">
											Are you sure want to make
											{{ selectedItem.bank_name }} inactive?
										</p>
										<p v-else>
											Are you sure want to delete {{ selectedItem.bank_name }}?
										</p>
									</div>
								</div>
								<div class="modal-btn delete-action">
									<div class="row d-flex flex-column align-items-center">
										<div class="col-6 mb-2">
											<button
												v-if="selectedAction === 'preferred'"
												@click="setPreferredBank()"
												:disabled="isLoading"
												class="w-100 btn btn-primary"
											>
												<span
													v-if="isLoading"
													class="spinner-border spinner-border-sm me-1"
													role="status"
													aria-hidden="true"
												></span>
												<span v-if="!isLoading">Save</span>
												<span v-if="isLoading">Saving...</span>
											</button>
											<button
												v-else-if="selectedAction === 'inactive'"
												@click="removePreferredBank()"
												:disabled="isLoading"
												class="w-100 btn btn-primary"
											>
												<span
													v-if="isLoading"
													class="spinner-border spinner-border-sm me-1"
													role="status"
													aria-hidden="true"
												></span>
												<span v-if="!isLoading">Save</span>
												<span v-if="isLoading">Saving...</span>
											</button>
											<button
												v-else
												@click="deleteBank()"
												:disabled="isLoading"
												class="w-100 btn btn-primary"
											>
												<span
													v-if="isLoading"
													class="spinner-border spinner-border-sm me-1"
													role="status"
													aria-hidden="true"
												></span>
												<span v-if="!isLoading">Delete</span>
												<span v-if="isLoading">Deleting...</span>
											</button>
										</div>
										<div class="col-6 mb-4">
											<button
												type="button"
												class="w-100 btn btn-primary paid-cancel-btn"
												data-bs-dismiss="modal"
											>
												Cancel
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- /Delete Category Modal -->
				</div>
			</div>
		</div>
		<!-- /Page Wrapper -->
	</div>
	<!-- /Main Wrapper -->
</template>
<script setup>
import { ref, onMounted, computed } from "vue";
import { Modal } from "bootstrap";
import { useStore } from "vuex";

const store = useStore();
const addBankModal = ref(null);
const editBankModal = ref(null);
const modalInstance = ref(null);
const isLoading = ref(false);
const isResolving = ref(false)
const isFetching = ref(false);
const title = "Settings";
const bank_id = ref(null);
const selectedItem = ref(null);
const selectedAction = ref(null);
const currency = localStorage.getItem('currency')

const resetForm = () => {
  form.value = {
    bank_name: "",
    account_name: "",
    account_number: "",
     preferred: 1,
    other_info: "",
  };
};

const form = ref({
  bank_name: "",
  account_name: "",
  account_number: "",
  preferred: 1,
  ifsc_code: "",
});

const bank_code = ref(null)

const setCode = () => {
  const selectedBank = bank_list.value.find(bank => bank.name === form.value.bank_name)
	bank_code.value = selectedBank.code
  fetchAccount()
}

const fetchAccount = () => {
	if (currency === 'NGN' && form.value.account_number.length == 10 && bank_code.value !== null) {
    resolveBank()
	}
}

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Bank",
    key: "bank_name",
    dataIndex: "bank_name",
    sorter: true,
  },
  {
    title: "Account Name",
    key: "account_name",
    dataIndex: "account_name",
    sorter: true,
  },
  {
    title: "Account Number",
    key: "account_number",
    dataIndex: "account_number",
    sorter: true,
  },
  {
    title: "Status",
    key: "preferred",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const closeAddModal = async () => {
  addBankModal.value.hide();
  resetForm();
};
const closeEditModal = async () => {
  editBankModal.value.hide();
	resetForm();
  getBanks()
};
const openEditModal = async (data) => {
  form.value = await data;
  if (data.preferred === true) {
    form.value.preferred = 1
  }
  else {
    form.value.preferred = 0
  }
  editBankModal.value.show();
  bank_id.value = data.id;
};
const openModal = (bank, name = "delete") => {
  selectedItem.value = bank;
  selectedAction.value = name;
  modalInstance.value.show();
};

const banks = computed(() => {
  return store.getters["settings/banks"];
});

const bank_list = computed(() => {
  return store.getters["settings/bank_list"];
});
const resolved_bank = computed(() => {
  return store.getters["settings/resolved_bank"];
});

const getBanks = () => {
  isFetching.value = true;
  store
    .dispatch("settings/getBankAccounts")
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};

const getBankList = () => {
  store
    .dispatch("settings/getBankList")
};

const resolveBank = async () => {
	isResolving.value = true
	let data = {
		acc_no: form.value.account_number,
		bank_code:bank_code.value
	}
  await store
	  .dispatch("settings/resolveBank",data).then(() => {
		  form.value.account_name = resolved_bank.value.account_name
		isResolving.value = false
	  }).catch(() => {
		  isResolving.value = false
		form.value.account_name = ''
	})
};

const addBank = () => {
  isLoading.value = true;
  store
    .dispatch("settings/addBankAccount", form.value)
    .then(() => {
      isLoading.value = false;
      closeAddModal();
    })
    .catch(() => {
      isLoading.value = false;
    });
};
const updateBank = () => {
  isLoading.value = true;
  let data = {
    payload: form.value,
    id: bank_id.value,
  };
  store
    .dispatch("settings/updateBankAccount", data)
    .then(() => {
      isLoading.value = false;
      closeEditModal();
    })
    .catch(() => {
      isLoading.value = false;
    });
};

const deleteBank = () => {
  isLoading.value = true;
  store
    .dispatch("settings/deleteBank", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      modalInstance.value.hide();
    })
    .catch(() => {
      modalInstance.value.hide();
    });
};
const setPreferredBank = () => {
  isLoading.value = true;
  store
    .dispatch("settings/setPreferredBank", selectedItem.value.id)
    .then(() => {
      isLoading.value = false;
      modalInstance.value.hide();
    })
    .catch(() => {
      modalInstance.value.hide();
    });
};
const removePreferredBank = () => {
  isLoading.value = true;
  store
    .dispatch("settings/removePreferredBank")
    .then(() => {
      isLoading.value = false;
      modalInstance.value.hide();
    })
    .catch(() => {
      modalInstance.value.hide();
    });
};

onMounted(() => {
  getBanks();
  getBankList()
  addBankModal.value = new Modal(document.getElementById("add_bank"), {
    backdrop: "static",
    keyboard: false,
  });
  editBankModal.value = new Modal(document.getElementById("edit_bank"), {
    backdrop: "static",
    keyboard: false,
  });
  modalInstance.value = new Modal(document.getElementById("delete_bank"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>

<style scoped>
.name-wrapper{
	position: relative;
}

.resolve-spinner{
	position: absolute;
	top: 13px;
	right: 10px;
	color: #3865b0;
}
</style>
